// -----------------------------
// swiper系
// -----------------------------


(function () {
  //swiper
  // let sampleSlide = new Swiper(".js-sample-slide", {
  //   navigation: {
      // nextEl: ".sample-button-next",
      // prevEl: ".sample-button-prev",
  //   },
  //   pagination: {                       //ページネーション（ドット）
  //       el: '.sample-pagination',
  //   },
  //   autoplay: true,
  //   loop: true,
  //   speed: 600,
  //   slidesPerView: 1,
  //   spaceBetween: 30,
  //   breakpoints: {
  //     769: {
  //       spaceBetween: 30,
  //       slidesPerView: 1,
  //     },
  //   },
  // });

  let campaignSlide = new Swiper(".js-campaign-slide", {
    navigation: {
      nextEl: ".campaign-button-next",
      prevEl: ".campaign-button-prev",
    },
    pagination: {                       //ページネーション（ドット）
      el: '.campaign-pagination',
      clickable: true,
    },
    autoplay: true,
    speed: 600,
    slidesPerView: 1,
    loop: true,
    // grid: {
    //   rows: 2,
    //   fill:'row',

    // },
    spaceBetween: 60,
    breakpoints: {
      769: {
        spaceBetween: 60,
        slidesPerView: 3,
        // grid: {
        //   rows: 1,
        //   fill:'column',
        // },
      },
    },
  });


})();
